var _class;
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { InlinePanelLayout } from "abreact/expression/layout/InlinePanelLayout";
import { OperandName } from "abreact/expression/ui/editor/impl/model/impl/conditional/IfThenElseModel";
import { NonBooleanValueEditor } from "abreact/expression/ui/editor/impl/model/impl/conditional/NonBooleanValueEditor";
import { GEECompletenessIndicator } from "abreact/expression/ui/editor/impl/utils/GEECompletenessIndicator";
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbVBox } from "abreact/layout/AbVBox";
import { AbButton, AbButtonType } from "abreact/misc/AbButton";
import { AbLabel } from "abreact/misc/AbLabel";
import { AbSize } from "abreact/misc/AbSize";
import { AbHBox } from "absdk/commons/ui/layout/AbHBox";
import { AbMaybePromise } from "abweb/utils/async/AbMaybePromise";
import { action } from "mobx";
import { observer } from "mobx-react";
import React from "react";
// import OperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperandValue;
// import OperatorOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperatorOperandValue;

export let IfThenElseFunctionEditor = observer(_class = class IfThenElseFunctionEditor extends React.Component {
  constructor(props) {
    super(props);
    this.applyOperandValue = this.applyOperandValue.bind(this);
  }
  render() {
    return /*#__PURE__*/React.createElement(AbVBox, {
      spacing: true,
      className: "ab-gee-nonboolean-editor-if-then-else-outer",
      dataTestId: `if-then-else-outer-${this.props.ifThenElseOperandValueModel.position}`
    }, this.editorLines);
  }
  get editorLines() {
    const {
      ifThenElseOperandValueModel,
      ifThenElseModel
    } = this.props;
    const editorLines = [];
    editorLines.push(this.createEditorLine(OperandName.IF, ifThenElseOperandValueModel.ifOperandValue));
    editorLines.push(this.createEditorLine(OperandName.THEN, ifThenElseOperandValueModel.thenOperandValue));
    if (ifThenElseModel.isElse(ifThenElseOperandValueModel)) {
      editorLines.push(this.createEditorLine(OperandName.ELSE, ifThenElseOperandValueModel.elseOperandValue));
    }
    editorLines.push(/*#__PURE__*/React.createElement(AbHBox, {
      spacing: true
    }, this.createAddButton(ifThenElseOperandValueModel), ifThenElseModel.modelList.length > 1 && this.createDeleteButton(ifThenElseOperandValueModel)));
    return editorLines;
  }
  createAddButton(operandValueModel) {
    return /*#__PURE__*/React.createElement(AbButton, {
      className: "ab-gee-nonboolean-editor-button",
      dataTestId: `nonboolean-editor-add-button-${this.props.ifThenElseOperandValueModel.position}`,
      type: AbButtonType.LINK,
      size: AbSize.EXTRA_SMALL,
      label: AbReactResources.nonboolean_editor_add_condition(),
      onClick: () => this.handleAdd(operandValueModel)
    });
  }
  createDeleteButton(operandValueModel) {
    return /*#__PURE__*/React.createElement(AbButton, {
      className: "ab-gee-nonboolean-editor-button",
      dataTestId: `nonboolean-editor-delete-button-${this.props.ifThenElseOperandValueModel.position}`,
      type: AbButtonType.LINK,
      size: AbSize.EXTRA_SMALL,
      label: AbReactResources.nonboolean_editor_delete_condition(),
      onClick: () => this.handleDelete(operandValueModel)
    });
  }
  handleDelete(model) {
    this.props.ifThenElseModel.deleteModel(model);
    this.applyModel();
  }
  handleAdd(after) {
    this.props.ifThenElseModel.addModel(after, this.props.generateId());
    this.applyModel();
  }
  createLabel(operandName) {
    let label;
    switch (operandName) {
      case OperandName.IF:
        if (!this.props.ifThenElseModel.isTopIf(this.props.ifThenElseOperandValueModel)) {
          label = AbReactResources.nonboolean_editor_elseIf_label();
        } else {
          label = AbReactResources.nonboolean_editor_if_label();
        }
        break;
      case OperandName.THEN:
        label = AbReactResources.nonboolean_editor_then_label();
        break;
      case OperandName.ELSE:
        label = AbReactResources.nonboolean_editor_else_label();
        break;
      default:
        throw new Error("unsupported operand name: " + operandName);
    }
    return label;
  }
  createEditorLine(operandName, operandValue) {
    return /*#__PURE__*/React.createElement(InlinePanelLayout.Container, {
      className: `ab-gee-nonboolean-editor-${operandName}`,
      dataTestId: `${operandName}-input-${this.props.ifThenElseOperandValueModel.position}`
    }, /*#__PURE__*/React.createElement(AbLabel, {
      className: "ab-gee-nonboolean-editor-conditional-label",
      label: this.createLabel(operandName)
    }), this.createNonBooleanValueEditor(operandName, operandValue), /*#__PURE__*/React.createElement(GEECompletenessIndicator, {
      isComplete: operandValue != null || operandName === OperandName.ELSE,
      tooltip: AbReactResources.nonboolean_editor_input_required_tooltip()
    }));
  }
  createNonBooleanValueEditor(operandName, operandValue) {
    return /*#__PURE__*/React.createElement(NonBooleanValueEditor, {
      currentValue: operandValue,
      operatorOperandValue: this.props.ifThenElseOperandValueModel.ifThenElseOperatorOperandValue,
      operandName: operandName,
      expressionComponentFactory: this.props.expressionComponentFactory,
      expressionDomainModel: this.props.expressionDomainModel,
      generateId: this.props.generateId,
      applyOperandValue: this.applyOperandValue,
      dataTestIdSuffix: "" + this.props.ifThenElseOperandValueModel.position
    });
  }
  applyModel() {
    this.props.applyOperatorOperandValue(this.props.ifThenElseModel.rootIfThenElseOperatorOperandValue);
  }
  applyOperandValue(operandName, operandValueMaybePromise) {
    const {
      ifThenElseOperandValueModel,
      applyOperatorOperandValue,
      ifThenElseModel
    } = this.props;
    AbMaybePromise.map(operandValueMaybePromise, action(operandValue => {
      ifThenElseModel.setOperandValue(ifThenElseOperandValueModel, operandName, operandValue);
      this.props.applyOperatorOperandValue(ifThenElseModel.rootIfThenElseOperatorOperandValue);
    }));
  }
}) || _class;
//# sourceMappingURL=IfThenElseFunctionEditor.js.map
